// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"styles_moreInfo__we1Mz"};